/**
 * Custom error class for HTTP error handling
 */
export class HttpError implements Error {
  constructor(message: string, code: number, stack?: string) {
    this.message = message;
    this.code = code;
    this.name = "HttpError";
  }
  public message: string;
  public code: number;
  public name: string;
}
